<template>
  <div id="landing-page">
    <site-header
      :smartphoneMenuOpened="smartphoneMenuOpened"
      @toggleSmartphoneMenu="toggleSmartphoneMenu"
    />
    <transition name="smartphone-menu">
      <smartphone-site-menu
        v-if="isSmartphone && smartphoneMenuOpened"
        @clickLink="toggleSmartphoneMenu"
      />
    </transition>
    <div id="main-layout-flex" :class="{ 'has-left-bar': pageHasLeftBar }">
      <left-bar v-if="!isSmartphone" />
      <div id="right-content">
        <router-view class="router-view-content" />
        <site-footer />
      </div>
    </div>
    <smartphone-floating-basket v-if="isSmartphone" />
<!--    <gif-animation />-->
  </div>
</template>

<script>
  import SiteHeader from '/src/blocks/SiteHeader'
  import SiteFooter from '/src/blocks/SiteFooter'
  import LeftBar from '/src/blocks/LeftBar'
  import SmartphoneSiteMenu from '/src/blocks/SmartphoneSiteMenu'
  import SmartphoneFloatingBasket from '/src/components/SmartphoneFloatingBasket'
  import GifAnimation from '/src/components/GifAnimation'

  import { mapActions } from 'vuex'

  export default {
    name: 'IndexPage',
    data () {
      return {
        smartphoneMenuOpened: false
      }
    },
    components: {
      SiteHeader,
      SiteFooter,
      LeftBar,
      SmartphoneSiteMenu,
      SmartphoneFloatingBasket,
      GifAnimation
    },
    methods: {
      ...mapActions({
        loadCategories: 'menu/loadCategories',
        loadPromotions: 'content/loadPromotions'
      }),
      toggleSmartphoneMenu () {
        this.smartphoneMenuOpened = !this.smartphoneMenuOpened
      }
    },
    mounted () {
      this.loadCategories()
      this.loadPromotions()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Index.vue